import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { ImpactStatsSection } from '../components/ImpactStatsSection';
import { AboutSection } from '../components/AboutSection';
import { WhyLadyHustlerSection } from '../components/WhyLadyHustlerSection';
import { WhatWeDoSection } from '../components/WhatWeDoSection';
import { SuccessPathSection } from '../components/SuccessPathSection';
import { HowWeOperateSection } from '../components/HowWeOperateSection';
import { UNCredibilitySection } from '../components/UNCredibilitySection';
import { MembershipSection } from '../components/MembershipSection';
import { GetInvolvedSection } from '../components/GetInvolvedSection';
import { ClosingGapCampaignSection } from '../components/ClosingGapCampaignSection';
import {
  GlobalFootprintSection,
  MissionSection,
  PublicEventsSection,
  TestimonialsSection,
  WordsToLiveBySection,
  ManifestoSection
} from '../components/AdditionalSections';
import { Footer } from '../components/Footer';

const Home = () => {
  useEffect(() => {
    // Enable smooth scrolling
    document.documentElement.classList.add('smooth-scroll');
    
    // Intersection Observer for fade-in animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-up');
        }
      });
    }, observerOptions);

    // Observe all sections
    const sections = document.querySelectorAll('section');
    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, []);

  return (
    <div className="App">
      <Navigation />
      <HeroSection />
      <ImpactStatsSection />
      <AboutSection />
      <WhyLadyHustlerSection />
      <WhatWeDoSection />
      <SuccessPathSection />
      <HowWeOperateSection />
      <UNCredibilitySection />
      <MembershipSection />
      <GetInvolvedSection />
      <ClosingGapCampaignSection />
      <GlobalFootprintSection />
      <MissionSection />
      <PublicEventsSection />
      <TestimonialsSection />
      <WordsToLiveBySection />
      <ManifestoSection />
      <Footer />
    </div>
  );
};

export default Home;
